import isNumber from 'lodash/isNumber'
import isString from 'lodash/isString'

export const isStringOrNumber = (value: unknown): boolean => isString(value) || isNumber(value)
